function Loader(){
    return(
        <div style={{ padding: ".5rem" }}>
            <div className="dot-flashing"></div>
        </div>
    )
}

export default Loader